import { Map, fromJS } from 'immutable';

import {
  setInputValueType,
  setIsLoadingType,
  setSelectedMapType,
  addSelectedType,
  clearSearchType,
} from './QuickSearchAutosuggestConstants';

export const initialState = fromJS({
  inputValue: '',
  isLoading: false,
  selectedMap: Map(),
});

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case setInputValueType: {
      const { inputValue } = action.payload;
      return state.set('inputValue', inputValue);
    }
    case setIsLoadingType: {
      const { isLoading } = action.payload;
      return state.set('isLoading', isLoading);
    }
    case setSelectedMapType: {
      const { selectedMap } = action.payload;

      return state.set('selectedMap', selectedMap);
    }
    case addSelectedType: {
      const { key, title, Typeahead, analytics } = action.payload;

      return state.setIn(
        ['selectedMap', key],
        fromJS({
          title,
          Typeahead,
          analytics,
        })
      );
    }
    case clearSearchType: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
